export const paymentType = [
  { value: 'Cash', label: 'Cash' },
  { value: 'Cheque', label: 'Cheque' },
  { value: 'Bank_transfer', label: 'Bank Transfer' },
  { value: 'Upi', label: 'UPI' },
  { value: 'Card', label: 'Card' },
  { value: 'Other', label: 'Other' },
];

export const paymentStatus = [
  { value: 'Paid', label: 'Paid' },
  { value: 'UnPaid', label: 'UnPaid' },
];

export const transStatus = [
  { value: 'Complete', label: 'Complete' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Ordered', label: 'Ordered' },
];

export const scheduleMode = [
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Yearly', label: 'Yearly' },
];

export const deliveryStatus = [
  { value: 'Ordered', label: 'Ordered' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Delivered', label: 'Delivered' },
];

export const status = [
  { value: 'Pending', label: 'Pending' },
  { value: 'Completed', label: 'Completed' },
];

export const regexOnNumberGraterThanZero = {
  pattern: /^(?!0(\.0+)?$)\d+(\.\d+)?$/,
  message: 'Invalid input. Please enter a number greater than or equal to 1.',
};
